import PropTypes from "prop-types";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { gr } from "../tokens";

// Paper look shared by every popover (menus, top-bar panels): radius 12, hairline border, raised shadow.
export const grPopoverPaperSx = {
  borderRadius: gr.radius.tile,
  border: `1px solid ${gr.color.line}`,
  boxShadow: gr.shadow.raised,
  backgroundImage: "none",
};

// Popover menu: radius 12, hairline border, raised shadow. Use GrMenuItem for items.
export function GrMenu({ children, PaperProps, ...rest }) {
  return (
    <Menu
      PaperProps={{
        ...PaperProps,
        sx: {
          minWidth: 200,
          mt: gr.space[1],
          ...grPopoverPaperSx,
          "& .MuiList-root": { padding: gr.space[1] },
          ...(PaperProps && PaperProps.sx),
        },
      }}
      {...rest}
    >
      {children}
    </Menu>
  );
}

GrMenu.propTypes = {
  children: PropTypes.node,
  PaperProps: PropTypes.object,
};

export function GrMenuItem({ danger = false, children, sx, ...rest }) {
  return (
    <MenuItem
      sx={{
        minHeight: gr.control.md,
        borderRadius: gr.radius.chip,
        gap: gr.space[2],
        fontFamily: gr.font.family,
        fontSize: gr.font.size.md,
        color: danger ? gr.color.danger : gr.color.ink,
        "&:hover": { background: danger ? gr.color.dangerSoft : gr.color.tint },
        "&.Mui-focusVisible": { background: gr.color.tint },
        "& svg": {
          width: 18,
          height: 18,
          color: danger ? gr.color.danger : gr.color.ink2,
        },
        ...sx,
      }}
      {...rest}
    >
      {children}
    </MenuItem>
  );
}

GrMenuItem.propTypes = {
  danger: PropTypes.bool,
  children: PropTypes.node,
  sx: PropTypes.object,
};

export default GrMenu;
